import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=4a6f8900&scoped=true"
import script from "./EditRole.vue?vue&type=script&lang=js"
export * from "./EditRole.vue?vue&type=script&lang=js"
import style0 from "./EditRole.vue?vue&type=style&index=0&id=4a6f8900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f8900",
  null
  
)

export default component.exports